export enum CALENDAR_TABS {
  BOOKINGS = 'bookings',
  OVERVIEW = 'overview',
}

export enum BOOKING_FILTERS {
  SEARCH = 'SEARCH',
  TYPE = 'TYPE',
  DATE_RANGE = 'DATE_RANGE',
  RESERVATION_STATUSES = 'RESERVATION_STATUSES',
  PAYOUT_STATUSES = 'PAYOUT_STATUSES',
  ID = 'ID',
  CLIENT_NAME = 'CLIENT_NAME',
  SERVICE_NAME = 'SERVICE_NAME',
  QUEST = 'QUEST',
  REQUEST = 'REQUEST',
  DATE = 'DATE',
}
